import sampleSearchTexts from '@/data/artworks-search-texts.json';

export default {

    data: function () {
        return {
            sampleClassifications: [
                'maalaus',
                'veistos',
                'grafiikka',
                'piirustus',
                'esineteos',
                'installaatio',
                'mediataide',
                'tekstiili',
                'tilateos',
                'valokuva'
            ],
            sampleSubClassifications: [
                'akvarelli',
                'installaatio',
                'kollaasi',
                'lasimaalaus',
                'monumentaaliveistos',
                'mosaiikki',
                'painografiikka',
                'paperiveistos',
                'poltettu savi',
                'puupiirros',
                'reliefi',
                'ryijy',
                'sarjakuvaoriginaali',
                'seinämaalaus',
                'sekatekniikka',
                'taidegrafiikka',
                'tekstiili',
                'tilataideteos',
                'valoteos',
                'videoinstallaatio',
                'videokollaasi',
                'videoteos',
                'värivalokuva'
            ],
            sampleSearchTexts,
            highlightActorNames: [
                '(Erik Enroth)',
                '(Fanny Churberg)',
                '(Ferdinand von Wright)',
                '(Gallen-Kallela)',
                '(Helene Schjerfbeck)',
                '(Hjalmar Munsterhjelm)',
                '(Hugo Backmansson)',
                '(Hugo Simberg)',
                '(Järnefelt)',
                '(Kaarina Alsta)',
                '(Pekka Halonen)',
                '(Santeri Salokivi)',
                '(Venny Soldan-Brofelt)',
                '(Vilho Lampi)',
                '(Lyyli Säilä)'
            ],
            prominentActorNames: [
                '(Alexander Lauréus)',
                '(Alfred William Finch)',
                '(Alpo Jaakola)',
                '(Alvar Cawén)',
                '(Amélie Lundahl)',
                '(Berndt Lindholm)',
                '(Bruno Liljefors)',
                '(Edwin Lydén)',
                '(Eero Nelimarkka)',
                '(Eliel Saarinen)',
                '(Elin Danielson-Gambogi)',
                '(Ferdinand von Wright)',
                '(Fredrik Ahlstedt)',
                '(Gunnar Berndtson)',
                '(Hugo Backmansson)',
                '(Ivan Aivazovski)',
                '(Jalmari Ruokokoski)',
                '(Magnus von Wright)',
                '(Maria Wiik)',
                '(Matti Karppanen)',
                '(Robert Wilhelm Ekman)',
                '(Victor Westerholm)',
                '(Väinö Kamppuri)'
            ]
        };
    },

    methods: {
        getRandomClassification: function (without) {
            return _.head(_.shuffle(_.difference(this.sampleClassifications, without)));
        },

        getRandomSubClassification: function (without) {
            return _.head(_.shuffle(_.difference(this.sampleSubClassifications, without)));
        },

        getRandomSearchText: function (without) {
            return _.head(_.shuffle(_.difference(this.sampleSearchTexts, without)));
        },

        getHighlights: async function () {
            return new Promise((resolve, reject) => {
                // include Alsta and Säilä to every query
                // NOTE:     Make actor index highligs based on index.
                // const searchString = `(Kaarina Alsta) OR (Lyyli Säilä) OR (${_.join(_.shuffle(this.highlightActorNames), ' OR ')})`;
                this.$SVC.queryActors({
                    // Texts: [{Field: 'Name', Text: searchString}],
                    AutoWildcards: false,
                    EnableFacetedSearch: false,
                    UseProfile: this.getUseProfile_ViewCache(), // NOTE: the view needs to have UseProfileMixin
                    // PreferredLocale included by svc helpers
                    PageIndex: 0,
                    PageSize: 16,
                    // HasImage: false,
                    // SortField: 'TopicDate:desc,ReleaseDate:desc', // automatic relevance
                    Template: {
                        PrimaryProperties: true,
                        IndexProperties: true,
                        ObjectProperties: true,
                        IngressProperties: true,
                        CuratorProperties: false,
                        ArtworkProperties: false,
                        DetailProperties: false,
                        ImageInfoExtended: true
                    }
                })
                    .then((response) => {
                        const actors = response && response.data && response.data.Results;
                        let highlights = _.filter(_.shuffle(actors), {ActorType: 'taiteilija'});

                        // pick some selections to the top
                        _.shuffle(['Lyyli Säilä', 'Kaarina Alsta']).forEach((name) => {
                            const actor = _.head(_.filter(highlights, {Name: name}));
                            if (actor) {
                                highlights = _.pull(highlights, actor);
                                highlights.unshift(actor);
                            }
                        });

                        resolve(highlights);
                    })
                    .catch((error) => {
                        this.$emit('error', error);
                        reject(error);
                    });
            });
        }
    }
};
